import { Navigate, Outlet } from 'react-router-dom';
import { homeRouteFor } from '@config/routes';
import { useAuthStore } from '@stores/auth.store';
import { LoadingState } from '@shared/components';

/** For sign-in screens: send already-authenticated users into the app. */
export function GuestGuard(): React.JSX.Element {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  if (!isInitialized) return <LoadingState fullscreen />;
  if (isAuthenticated) {
    return <Navigate to={homeRouteFor(user?.role)} replace />;
  }
  return <Outlet />;
}
